/* eslint-disable react/react-in-jsx-scope */
import { useState, CSSProperties } from 'react'
import { PulseLoader } from 'react-spinners'

import APIService from '../../lib/api.service';

type State = {
  loading: boolean
  ok?: boolean
  msg?: string
  routedTo?: string
}

export default function ConstructionForm() {
  const [state, setState] = useState<State>({ loading: false });

  const [showForm, setShowForm] = useState(true);
  const [showSuccessPrompt, setShowSuccessPrompt] = useState(false);
  const [showFailedPrompt, setShowFailedPrompt] = useState(false);

  // Loading spinner configuration
  const [showLoader, setShowLoader] = useState(false);
  const color = "#FFA500"
  const override: CSSProperties = {
    display: "block",
    margin: "0 auto",
    borderColor: "orange",
  }

  const loaderContainerStyle: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2rem',
    width: '100%'
  }

  async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    const form = new FormData(e.currentTarget);

    setShowLoader(true); // Set spinner
    setShowForm(false);
    setShowSuccessPrompt(false);
    setShowFailedPrompt(false);

    const payload = {
      kind: 'construction',
      name: form.get('name'),
      email: form.get('email'),
      phone: form.get('phone'),
      message: form.get('message'),
      website: form.get('website'), // honeypot
    }

    // bot honeypot
    if (payload.website) {
      setShowSuccessPrompt(true);
      setShowLoader(false);
      return;
    }

    try {
      const submit = await APIService.postConstructionInfo(JSON.stringify(payload));

      setShowLoader(false);
      if (submit.status === 201) {
        setShowSuccessPrompt(true);
      } else if (submit.status === 500) {
        setShowFailedPrompt(true);
        setShowForm(true);
      }

    } catch (error) {
      setShowLoader(false);
      setShowFailedPrompt(true);
      setShowForm(true);
    }
  }

  return (
    <form className="form-card" onSubmit={onSubmit}>
      {showLoader && (
        <div style={loaderContainerStyle}>
          <PulseLoader
            color={color}
            loading={showLoader}
            cssOverride={override}
            size={50}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )}

      {showForm && (
        <>
          <div className="row">
            <label htmlFor="name">Name</label>
            <input id="name" name="name" required autoComplete="name" />
          </div>

          <div className="row">
            <label htmlFor="email">Email</label>
            <input id="email" name="email" type="email" required autoComplete="email" />
          </div>

          <div className="row">
            <label htmlFor="phone">Phone</label>
            <input id="phone" name="phone" type="tel" inputMode="tel" autoComplete="tel-national" />
          </div>

          <div className="row">
            <label htmlFor="message">Inquiry Description/Details</label>
            <input id="message" name="message" required />
          </div>

          {/* honeypot */}
          <input name="website" style={{ display: 'none' }} tabIndex={-1} aria-hidden="true" />
        </>
      )}

      {showSuccessPrompt && (
        <h3 className="headline__h3 color--marina-blue">
          Your inquiry has been submitted! Our construction team will reach out to you as soon as possible. If you have any questions, please contact us at <a href="mailto:construction@citysidefiber.com"> construction@citysidefiber.com.</a>
        </h3>
      )}

      {showFailedPrompt && (
        <h3 className="headline__h3 color--marina-blue">
          Hmm... it looks like we're having trouble submitting your inquiry. Try again in a couple minutes, and if that doesn't work, please contact us at <a href="mailto:construction@citysidefiber.com"> construction@citysidefiber.com.</a>
        </h3>
      )}

      <div className="actions">
        <button className="btn btn-primary" disabled={state.loading}>
          {state.loading ? 'Submitting…' : 'Submit'}
        </button>
        <span role="status" aria-live="polite" className={state.ok ? 'ok' : 'err'}>
          {state.ok !== undefined ? `${state.msg}${state.routedTo ? ` (to: ${state.routedTo})` : ''}` : ''}
        </span>
      </div>
    </form>
  )
}